/**
 * Created by Arif Topcu in 2019
 */

import React, { memo, useCallback } from "react";
import ComplicationSelector from "@ls/grouping-complication-selector";
import { useDispatch, useSelector } from "react-redux";
import AnalyticDefinition from "state/analytics/AnalyticDefinition";
import { setDefinition as setAnalyticDefinition } from "state/analytics/actions";
import { selectDefinitions } from "state/analytics/selectors";
import SelectionState from "state/selections/SelectionState";
import AnalyticsSelectorComplication from "./AnalyticsSelectorComplication";

const AnalyticsSelector = () => {
  const dispatch = useDispatch();
  const definitions = useSelector(
    selectDefinitions(SelectionState.UNCOMMITTED)
  );
  const setDefinition = useCallback(
    (definitions, idx) => dispatch(setAnalyticDefinition(definitions, idx)),
    [dispatch]
  );

  return (
    <ComplicationSelector
      selectedDefinitions={definitions}
      setDefinition={setDefinition}
      getDefaultDefinition={AnalyticDefinition.getDefault}
      ComplicationComponent={AnalyticsSelectorComplication}
      btnTitle={"Analytics"}
      addMoreText={"Analytic Column"}
    />
  );
};

export default memo(AnalyticsSelector);
